<template>
  <div class="myFileList flex">
    <div class="upload-image-list">
      <draggable
        class="syllable_ul"
        element="ul"
        :list="fileList"
        :options="{ group: 'title', animation: 150 }"
        :no-transition-on-drag="true"
      >
        <transition-group
          type="transition"
          class="flex flex-wrap"
          :name="!drag ? 'syll_li' : null"
          :css="true"
        >
          <div class="upload-image-item" v-for="(item, index) in fileList" :key="item.uid">
            <a-icon
              @click="removeCoupon(index)"
              class="close flex-c-c"
              type="close"
              v-if="!disabled"
            />
            <a-spin
              :spinning="
                !(
                  item.url ||
                  (item.response &&
                    (item.response.url || (item.response.result && item.response.result.url)))
                )
              "
            >
              <img
                :src="
                  item.url ||
                  (item.response &&
                    (item.response.url || (item.response.result && item.response.result.url)))
                "
                alt="img"
                class="upload-image"
                @click="
                  handlePreview(
                    item.url ||
                      (item.response &&
                        (item.response.url || (item.response.result && item.response.result.url)))
                  )
                "
              />
            </a-spin>
          </div>
        </transition-group>
      </draggable>
      <a-upload
        v-show="fileList.length < multiple"
        :multiple="true"
        :accept="accept"
        list-type="picture-card"
        :file-list="fileList"
        :disabled="disabled"
        :showUploadList="false"
        :before-upload="beforeUpload"
        :customRequest="customRequest"
        @change="handleChange"
        class="upload-button-inline"
      >
        <a-icon type="plus" />
        <div class="ant-upload-text">Upload</div>
      </a-upload>
    </div>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
import api from '@service/api'
import http from '@service/axios'
import draggable from 'vuedraggable'
import { Spin } from 'ant-design-vue'
import { getCookie } from '@/common/cookie'
export default {
  name: 'uploadImage',
  props: {
    multiple: {
      type: Number,
      default: 1,
    },
    imageList: {
      type: Array,
      default() {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    needSizeCheck: {
      //需要尺寸检测
      type: Boolean,
      default: true,
    },
    propsAccept: {
      type: Array,
      default: () => ['image/jpg', 'image/jpeg', 'image/png', 'image/bmp'],
    },
  },
  data() {
    return {
      drag: false,
      previewVisible: false,
      previewImage: '',
      fileList: [],
    }
  },
  inject: ['page'],
  computed: {
    uploadPartyFile() {
      let cpid = this.$store.getters.partyId
      let url = this.page === 'platformGoodsDetail' ? api.uploadLocal : api.uploadPartyFile
      return url + '?cpid=' + cpid
    },
    token() {
      return getCookie('d_session_id')
    },
    accept() {
      return this.propsAccept.join(',')
    },
  },
  watch: {
    imageList: {
      handler(newVal) {
        this.fileList = newVal
      },
      deep: true,
    },
  },
  components: {
    draggable,
    'a-spin': Spin,
  },
  mounted() {
    this.fileList = [...this.imageList]
  },
  methods: {
    async uploadToOSS(file) {
      const res = await http.post(api.filePreUpload, {
        file_name: file.name,
        appCode: 'GOODS',
        'Content-Type': file.type,
      })
      // http.post返回格式为 {code, result}
      const uploadData = res.result || res
      await fetch(uploadData.upload_url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': uploadData.content_type,
        },
      })
      return uploadData.image_url
    },
    async customRequest({ file, onSuccess, onError, onProgress }) {
      try {
        // 设置上传进度
        onProgress({ percent: 0 })
        // file可能是包装后的对象，需要获取原始文件对象
        const originFile = file.originFileObj || file
        const imageUrl = await this.uploadToOSS(originFile)
        onProgress({ percent: 100 })
        // 上传成功，调用onSuccess并传入图片URL
        onSuccess({ url: imageUrl }, file)
      } catch (error) {
        console.error('上传失败:', error)
        onError(error)
      }
    },
    handleChange({ file, fileList }) {
      this.fileList = fileList
      if (file && file.status === 'done') {
        this.$nextTick(() => {
          let imageUrl = null
          let partyFileId = null

          // OSS上传方式：图片URL直接存储在file.response.url中
          if (file.response && file.response.url) {
            imageUrl = file.response.url
          }
          // 兼容旧的上传方式：图片URL存储在file.response.result.url中
          else if (file.response && file.response.result && file.response.result.url) {
            imageUrl = file.response.result.url
            partyFileId = file.response.result.partyFileId
          }

          // 如果获取到图片URL，更新对应的文件项
          if (imageUrl) {
            this.fileList.forEach((item) => {
              if (item.uid === file.uid) {
                this.$set(item, 'url', imageUrl)
                if (partyFileId) {
                  this.$set(item, 'partyFileId', partyFileId)
                }
              }
            })
            this.$nextTick(() => {
              this.$emit('update:imageList', this.fileList)
              this.$emit('changeList', 'speed')
            })
          }
        })
      }
    },
    beforeUpload(file) {
      console.log('file: ', file)
      const isJPG = this.propsAccept.includes(file.type)
      if (!isJPG) {
        this.$notification['error']({
          message: '请上传图片文件',
        })
      }
      // const isLt2M = file.size / 1024 < 200 && file.size / 1024 > 10;
      // if (!isLt2M) {
      //   this.$error('文件大小应在10KB~20KB之间');
      // }
      // return isJPG && isLt2M
      const isSize = this.isSize(file)
      return isJPG && isSize
    },
    //检测尺寸
    isSize(file) {
      if (!this.needSizeCheck) {
        return Promise.resolve()
      }
      let img
      return new Promise((resolve, reject) => {
        //min 500x500 max 2000x2000
        let _URL = window.URL || window.webkitURL
        img = new Image()
        img.onload = function () {
          let valid =
            img.width >= 500 && img.width <= 2000 && img.height >= 500 && img.height <= 2000
          valid ? resolve() : reject()
        }
        img.src = _URL.createObjectURL(file)
      }).then(
        () => {
          return file
        },
        () => {
          this.$error(
            `${file.name}图片尺寸（${img.width}x${img.height}）不符合要求，请修改后重新上传！`
          )
          return Promise.reject()
        }
      )
    },
    removeCoupon(index) {
      // console.log(index, 3333)
      if (this.disabled) return
      this.fileList.splice(index, 1)
      this.$nextTick(() => {
        this.$emit('update:imageList', this.fileList)
        // 删除图片后也触发changeList，以便保存到服务器
        this.$emit('changeList', 'speed')
      })
    },
    handlePreview(url) {
      // console.log(1111)
      this.previewImage = url
      this.previewVisible = true
    },
  },
}
</script>
<style lang="scss" scoped>
ul {
  padding: 0;
}
// 因为我们用的ant的组件的class，会有些默认样式要去掉，如果样式是你自己写的，那就不需要这块了
.ant-upload-list {
  display: block !important;
}
.upload-image-list {
  display: flex;
  flex-wrap: wrap;
  // overflow-x: auto;
  .upload-image-item {
    width: 100px;
    height: 100px;
    position: relative;
    margin-right: 14px;
    margin-bottom: 10px;
    .close {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 2px;
      right: 2px;
      font-size: 10px;
      z-index: 99;
      opacity: 1;
      cursor: pointer;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.7);
      border-radius: 100%;
    }
    .upload-image {
      width: 100px;
      height: 100px;
      object-fit: cover;
    }
  }
  .upload-button-inline {
    margin-right: 14px;
    margin-bottom: 10px;
  }
}
.flex-wrap {
  flex-wrap: wrap;
}
.ant-upload-picture-card-wrapper {
  width: auto;
}
</style>
